import React, { useState, useEffect, useContext } from 'react';
import { FiMessageSquare, FiSend, FiUser, FiHeadphones } from 'react-icons/fi';
import axios from 'axios';
import '../../../../assets/css/admin/subscreens/support/AdminTicketChat.css';
import AppContext from '../../../../contexts/AppContext';

const AdminTicketChat = ({ ticketId, status, customerName, baseUrl }) => {
  const [ adminAuthToken ] =  useContext(AppContext);
  const [chatMessages, setChatMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');

  const fetchMessages = () => {
    axios
      .get(`${baseUrl}/admin/support/getMessages`, {
          headers: {
            Authorization: `Bearer ${adminAuthToken}`,
          },
      },
      {
        params: { ticket_id: ticketId },
      },
    )
      .then((res) => setChatMessages(res.data?.messages || []))
      .catch(() => {});
  };

  const handleSendMessage = () => {
    if (!newMessage.trim()) return;

    const formdata = new FormData();
    formdata.append('ticket_id', ticketId);
    formdata.append('message', newMessage);
    setNewMessage('');

    axios
      .post(`${baseUrl}/admin/support/sendMessage`, formdata, {
        headers: { 'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${adminAuthToken}`,
         },
      })
      .then(() => fetchMessages())
      .catch(() => {});
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  useEffect(() => {
    fetchMessages();
    const interval = setInterval(fetchMessages, 5000);
    return () => clearInterval(interval);
  }, [ticketId]);

  const isTicketClosed = status === 'Resolved' || status === 'Closed';

  return (
    <div className="atv-card admin-ticket-chat-card">
      <h3 className="atv-card-title">
        <FiMessageSquare /> Conversation with {customerName}
      </h3>

      <div className="admin-ticket-chat-messages">
        {chatMessages.map((msg) => (
          <div key={msg.id} className={`admin-ticket-chat-message ${msg.sender === 'chadmin' ? 'admin' : 'customer'}`}>
            <div className="admin-ticket-chat-avatar">
              {msg.sender === 'chadmin' ? <FiHeadphones /> : <FiUser />}
            </div>
            <div className="admin-ticket-chat-bubble">
              <div className="admin-ticket-chat-header">
                <span className="admin-ticket-chat-sender">
                  {msg.sender === 'chadmin' ? 'Support Team' : customerName}
                </span>
                <span className="admin-ticket-chat-time">
                  {new Date(msg.created_at).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}
                </span>
              </div>
              <p className="admin-ticket-chat-text">{msg.message}</p>
            </div>
          </div>
        ))}
      </div>

      {isTicketClosed ? (
        <div className="admin-ticket-chat-closed">
          <FiMessageSquare />
          <span>This ticket is closed. Reopen to send messages.</span>
        </div>
      ) : (
        <div className="admin-ticket-chat-input-row">
          <input
            type="text"
            className="admin-ticket-chat-input"
            placeholder="Type your response..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <button className="admin-ticket-chat-send-btn" onClick={handleSendMessage}>
            <FiSend />
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminTicketChat;